"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.loading.title': 'Attivazione del tuo account',
    'activate.loading.message': 'Attendi mentre attiviamo il tuo account...',
};
